export default __webpack_public_path__ + "static/media/logo.a1854801.svg";